import React from 'react';
import {
    Box,
    Button,
    Card,
    TextField,
    Typography
} from '@mui/material';

const DEFAULT_PRIVACY_POLICY = `Introduction
Your privacy policy introduction...

Information We Collect
Details about data collection...

How We Use Your Information
How you use customer data...

Data Security
Security measures...

Contact Us
Contact information...`;

const DEFAULT_TERMS_OF_USE = `1. Acceptance of Terms
By using our services...

2. Use License
License terms...

3. User Account
Account responsibilities...

4. Payment Terms
Payment policies...

5. Limitation of Liability
Liability limitations...`;

const LegalDocumentsEditor = ({ domainPublicSettings, setDomainPublicSettings }) => {
    const getContent = (policy) => {
        if (!policy || !policy.sections || policy.sections.length === 0) return '';
        return policy.sections[0]?.content || '';
    };

    const setContent = (key, content) => {
        setDomainPublicSettings(prev => ({
            ...prev,
            [key]: {
                sections: [{ title: '', content }]
            }
        }));
    };

    const privacyPolicyContent = getContent(domainPublicSettings.PRIVACY_POLICY);
    const termsOfUseContent = getContent(domainPublicSettings.TERMS_OF_USE);

    return (
        <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
                Legal Documents
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Customize your Privacy Policy and Terms of Use that will be shown to users
            </Typography>

            {/* Privacy Policy Editor */}
            <Card sx={{ mb: 2, p: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                    Privacy Policy
                </Typography>
                {!privacyPolicyContent ? (
                    <Button
                        variant="outlined"
                        onClick={() => setContent('PRIVACY_POLICY', DEFAULT_PRIVACY_POLICY)}
                    >
                        Generate Default Privacy Policy
                    </Button>
                ) : (
                    <Box>
                        <TextField
                            fullWidth
                            multiline
                            rows={12}
                            value={privacyPolicyContent}
                            onChange={(e) => setContent('PRIVACY_POLICY', e.target.value)}
                            placeholder="Enter your Privacy Policy here..."
                        />
                        <Button
                            size="small"
                            color="error"
                            onClick={() => setDomainPublicSettings(prev => ({
                                ...prev,
                                PRIVACY_POLICY: { sections: [] }
                            }))}
                            sx={{ mt: 1 }}
                        >
                            Clear
                        </Button>
                    </Box>
                )}
            </Card>

            {/* Terms of Use Editor */}
            <Card sx={{ p: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>
                    Terms of Use
                </Typography>
                {!termsOfUseContent ? (
                    <Button
                        variant="outlined"
                        onClick={() => setContent('TERMS_OF_USE', DEFAULT_TERMS_OF_USE)}
                    >
                        Generate Default Terms of Use
                    </Button>
                ) : (
                    <Box>
                        <TextField
                            fullWidth
                            multiline
                            rows={12}
                            value={termsOfUseContent}
                            onChange={(e) => setContent('TERMS_OF_USE', e.target.value)}
                            placeholder="Enter your Terms of Use here..."
                        />
                        <Button
                            size="small"
                            color="error"
                            onClick={() => setDomainPublicSettings(prev => ({
                                ...prev,
                                TERMS_OF_USE: { sections: [] }
                            }))}
                            sx={{ mt: 1 }}
                        >
                            Clear
                        </Button>
                    </Box>
                )}
            </Card>
        </Box>
    );
};

export default LegalDocumentsEditor;
